// LIST
export const FETCH_REVIEWS = "app/Reviews/FETCH_REVIEWS";
export const FETCH_REVIEWS_SUCCESS = "app/Reviews/FETCH_REVIEWS_SUCCESS";
export const FETCH_REVIEWS_FAILURE = "app/Reviews/FETCH_REVIEWS_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/Reviews/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/Reviews/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/Reviews/GET_VIEW_DATA_FAILURE";
// ADD
export const ADD_REVIEWS = "app/Reviews/ADD_REVIEWS";
export const ADD_REVIEWS_SUCCESS = "app/Reviews/ADD_REVIEWS_SUCCESS";
export const ADD_REVIEWS_FAILURE = "app/Reviews/ADD_REVIEWS_FAILURE";
// EDIT
export const EDIT_REVIEWS = "app/Reviews/EDIT_REVIEWS";
export const EDIT_REVIEWS_SUCCESS = "app/Reviews/EDIT_REVIEWS_SUCCESS";
export const EDIT_REVIEWS_FAILURE = "app/Reviews/EDIT_REVIEWS_FAILURE";
// DELETE
export const DELETE_REVIEWS = "app/Reviews/DELETE_REVIEWS";
export const DELETE_REVIEWS_SUCCESS = "app/Reviews/DELETE_REVIEWS_SUCCESS";
export const DELETE_REVIEWS_FAILURE = "app/Reviews/DELETE_REVIEWS_FAILURE";
//
export const ADD_REPLY = "app/Reviews/ADD_REPLY";
export const ADD_REPLY_SUCCESS = "app/Reviews/ADD_REPLY_SUCCESS";
export const ADD_REPLY_FAILURE = "app/Reviews/ADD_REPLY_FAILURE";
//
export const EDIT_REPLY = "app/Reviews/EDIT_REPLY";
export const EDIT_REPLY_SUCCESS = "app/Reviews/EDIT_REPLY_SUCCESS";
export const EDIT_REPLY_FAILURE = "app/Reviews/EDIT_REPLY_FAILURE";
//
export const DELETE_REPLY = "app/Reviews/DELETE_REPLY";
export const DELETE_REPLY_SUCCESS = "app/Reviews/DELETE_REPLY_SUCCESS";
export const DELETE_REPLY_FAILURE = "app/Reviews/DELETE_REPLY_FAILURE";
//
export const TOGGLE_DELETE = "app/Reviews/TOGGLE_DELETE";
export const TOGGLE_ASK = "app/Reviews/TOGGLE_ASK";
// ADD
export const REQ_REVISE = "app/Reviews/REQ_REVISE";
export const REQ_REVISE_SUCCESS = "app/Reviews/REQ_REVISE_SUCCESS";
export const REQ_REVISE_FAILURE = "app/Reviews/REQ_REVISE_FAILURE";
//
export const TOGGLE_PHOTOS = "app/Reviews/TOGGLE_PHOTOS";
export const TOGGLE_VIDEOS = "app/Reviews/TOGGLE_VIDEOS";
export const TOGGLE_RATING = "app/Reviews/TOGGLE_RATING";
//
export const SET_IMG_FILTERS = "app/Reviews/SET_IMG_FILTERS";
//
export const GET_IMAGE = "app/Reviews/GET_IMAGE";
export const GET_IMAGE_SUCCESS = "app/Reviews/GET_IMAGE_SUCCESS";
export const GET_IMAGE_FAILURE = "app/Reviews/GET_IMAGE_FAILURE";
// ADD
export const ADD_REVIEW_CARD = "app/Reviews/ADD_REVIEW_CARD";
export const ADD_REVIEW_CARD_SUCCESS = "app/Reviews/ADD_REVIEW_CARD_SUCCESS";
export const ADD_REVIEW_CARD_FAILURE = "app/Reviews/ADD_REVIEW_CARD_FAILURE";

export const TOGGLE_PIN_MODAL = "app/Reviews/TOGGLE_PIN_MODAL";

export const FETCH_UPLOADS = "app/Reviews/FETCH_UPLOADS";
export const FETCH_UPLOADS_SUCCESS = "app/Reviews/FETCH_UPLOADS_SUCCESS";
export const FETCH_UPLOADS_FAILURE = "app/Reviews/FETCH_UPLOADS_FAILURE";

export const TOGGLE_CARD_MODAL = "app/Reviews/TOGGLE_CARD_MODAL";

export const TOGGLE_INSTRUCTIONS = "app/Reviews/TOGGLE_INSTRUCTIONS";
